/**
 * NEWLY-ADDED-HIGHLIGHT
 * Repere de l'element qui vient d'etre cree : la vue s'y deplace, il zoome une fois, et une
 * pastille verte le nomme. Meme habillage pour un risque et pour une mesure de prevention.
 * La pastille s'efface d'elle-meme au bout de 10 secondes (fondu porte par le CSS) : passe ce
 * delai elle n'apprend plus rien et alourdit la liste, alors que le zoom, lui, est deja fini.
 */
import { ReactNode, useEffect, useRef } from "react"

interface Props {
  children: ReactNode
  //Classes du conteneur (marges de la liste hote) : le repere ne doit pas changer la mise en page
  className?: string
  //Vrai pour le seul element concerne : l'appelant compare son id au repere porte par l'URL
  isActive: boolean
  label: string
}

export default function NewlyAddedHighlight({ children, className, isActive, label }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isActive) return

    const frame = requestAnimationFrame(() => {
      containerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
    })

    return () => cancelAnimationFrame(frame)
  }, [isActive])

  return (
    <div ref={containerRef} className={`relative w-full ${className ?? ""} ${isActive ? "newly-added" : ""}`}>
      {isActive && (
        <div className="newly-added-badge" role="status">
          {label}
        </div>
      )}
      <div className="newly-added-content">{children}</div>
    </div>
  )
}
